<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">
            {{ label }}
            <span v-if="required" class="text-red-500 text-l">*</span>
        </label>
        <select
            :id="id"
            ref="input"
            v-model="selected"
            v-bind="{ ...$attrs, class: null }"
            class="form-select"
            :class="{ error: error }"
            :required="required"
        >
            <slot />
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`
            },
        },
        error: String,
        label: String,
        required: {
            type: Boolean,
            default() {
                return false
            }
        },
        modelValue: {
            type: [String, Number, Boolean, null],
            default: null
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            // local internal value mirroring the parent’s v-model
            selected: this.modelValue,
        }
    },
    watch: {
        // Whenever local `selected` changes, emit the update to the parent.
        selected(newVal) {
            this.$emit('update:modelValue', newVal)
        },
        // Whenever the parent changes `modelValue` (e.g. via reset),
        // update the local `selected` to keep them in sync.
        modelValue(newVal) {
            this.selected = newVal
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
